import { ShieldCheck } from "@phosphor-icons/react";

/**
 * "Protected by PriceGuard" trust mark - used in landing footer, email templates,
 * and detail pages. Placeholder for a future retailer-facing trust badge.
 *
 * <TrustMark variant="default|inverse|compact" />
 */
export default function TrustMark({ variant = "default" }) {
  const isInverse = variant === "inverse";
  const isCompact = variant === "compact";

  return (
    <span
      className={`inline-flex items-center gap-2 ${isCompact ? "text-[11px]" : "text-xs"}`}
      data-testid="trust-mark"
      aria-label="Protected by PriceGuard"
    >
      <span
        className={`inline-flex items-center justify-center ${isCompact ? "w-5 h-5" : "w-6 h-6"}`}
        style={{
          background: isInverse ? "#ffffff" : "#0a0a0a",
          color: isInverse ? "#0a0a0a" : "#ffffff",
        }}
      >
        <ShieldCheck size={isCompact ? 12 : 14} weight="fill" />
      </span>
      <span
        className="font-heading font-bold tracking-tight uppercase"
        style={{
          letterSpacing: "0.14em",
          color: isInverse ? "#ffffff" : "#0a0a0a",
          fontSize: isCompact ? "10px" : "11px",
        }}
      >
        Protected by <span style={{ color: isInverse ? "#ffffff" : "#002FA7" }}>PriceGuard</span>
      </span>
    </span>
  );
}
